import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { OrderTaxShortTermRentalJoinService } from '../order-tax-short-term-rental-join.service';
import { OrderTaxShortTermRentalJoin } from '../order-tax-short-term-rental-join';
import { OrderTaxShortTermRentalJoinComponent } from '../order-tax-short-term-rental-join/order-tax-short-term-rental-join.component';

@Component({
    selector: 'app-order-tax-short-term-rental-join-list',
    templateUrl: './order-tax-short-term-rental-join-list.component.html',
    styleUrls: ['./order-tax-short-term-rental-join-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class OrderTaxShortTermRentalJoinListComponent implements OnInit {
	constructor(
		private orderTaxShortTermRentalJoinService: OrderTaxShortTermRentalJoinService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = orderTaxShortTermRentalJoinService.statuses;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	@Input() orderTaxId: any;
	orderTaxShortTermRentalJoins: any;
	orderTaxShortTermRentalJoin: OrderTaxShortTermRentalJoin;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'OrderTaxVO.name', header: 'Order Tax Name', width: 'auto' },
		{ field: 'ShortTermRentalVO.propertyCode', header: 'Property Code', width: 'auto' },
		{ field: 'ShortTermRentalVO.bedrooms', header: 'Bedrooms', width: 'auto' },
		{ field: 'ShortTermRentalVO.addressCounty', header: 'County', width: 'auto' },
		
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.orderTaxShortTermRentalJoinId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-orderTaxShortTermRentalJoin-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			if(this.orderTaxId)
			{
				// show only activities that are assigned to this activityId
				let orderTaxIdFilter = { 'orderTaxId': { 'value': this.orderTaxId, 'matchMode': 'in' } };
				Object.assign(event.filters, orderTaxIdFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.orderTaxShortTermRentalJoinService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.orderTaxShortTermRentalJoins = res.data.taxShortTermRentalJoins;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.orderTaxShortTermRentalJoins = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(orderTaxShortTermRentalJoin: OrderTaxShortTermRentalJoin) {
		try {
			this.formLoading = true;
			this.orderTaxShortTermRentalJoinService.update(orderTaxShortTermRentalJoin)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.orderTaxShortTermRentalJoins.map((orderTaxShortTermRentalJoin, i) => {
							if (orderTaxShortTermRentalJoin.orderTaxShortTermRentalJoinId === res.data.orderTaxShortTermRentalJoin.orderTaxShortTermRentalJoinId) {
								this.orderTaxShortTermRentalJoins[i] = res.data.orderTaxShortTermRentalJoin;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(orderTaxShortTermRentalJoin: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(orderTaxShortTermRentalJoin));

			this.formLoading = true;
			this.orderTaxShortTermRentalJoinService.delete(orderTaxShortTermRentalJoin.orderTaxShortTermRentalJoinId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.orderTaxShortTermRentalJoins.splice(this.orderTaxShortTermRentalJoins.indexOf(orderTaxShortTermRentalJoin), 1);
						this.recordTotal = this.orderTaxShortTermRentalJoins.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'OrderTaxShortTermRentalJoin ' + orderTaxShortTermRentalJoin.orderTaxShortTermRentalJoinId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'OrderTaxShortTermRentalJoin ' + orderTaxShortTermRentalJoin.orderTaxShortTermRentalJoinId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Order Tax ShortTermRental Join',
			orderTaxId: this.orderTaxId,
			orderTaxShortTermRentalFlag: false
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OrderTaxShortTermRentalJoinComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.addOrderTaxShortTermRentalJoinCB(data);
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				// dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(orderTaxShortTermRentalJoin: OrderTaxShortTermRentalJoin) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			orderTaxShortTermRentalJoin: orderTaxShortTermRentalJoin,
			orderTaxShortTermRentalFlag: true,
			orderTaxId: this.orderTaxId,
			title: 'Edit Order Tax ShortTermRental Join'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OrderTaxShortTermRentalJoinComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.updateOrderTaxShortTermRentalJoinCB(data);
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				// dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.deleteOrderTaxShortTermRentalJoinCB(data);
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addOrderTaxShortTermRentalJoinCB(orderTaxShortTermRentalJoin: OrderTaxShortTermRentalJoin) {
		console.log('Adding OrderTaxShortTermRentalJoin: ' + JSON.stringify(orderTaxShortTermRentalJoin));
		// if we don't have a orderTaxShortTermRentalJoins array yet...
		if (!this.orderTaxShortTermRentalJoins) {
			this.orderTaxShortTermRentalJoins = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.orderTaxShortTermRentalJoins.unshift(orderTaxShortTermRentalJoin);

		// no idea what this is but it is required to update the array
		this.orderTaxShortTermRentalJoins = [...this.orderTaxShortTermRentalJoins];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderTaxShortTermRentalJoin ' + orderTaxShortTermRentalJoin.orderTaxShortTermRentalJoinId + ' Added', life: 3000 });
	}

	updateOrderTaxShortTermRentalJoinCB(orderTaxShortTermRentalJoin: OrderTaxShortTermRentalJoin) {
		console.log('Updating OrderTaxShortTermRentalJoin: ' + JSON.stringify(orderTaxShortTermRentalJoin));
		let itemIndex = this.orderTaxShortTermRentalJoins.findIndex((item: any) => item.orderTaxShortTermRentalJoinId === orderTaxShortTermRentalJoin.orderTaxShortTermRentalJoinId);
		this.orderTaxShortTermRentalJoins[itemIndex] = orderTaxShortTermRentalJoin;

		// no idea what this is but it is required to update the array
		this.orderTaxShortTermRentalJoins = [...this.orderTaxShortTermRentalJoins];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderTaxShortTermRentalJoin ' + orderTaxShortTermRentalJoin.orderTaxShortTermRentalJoinId + ' Updated', life: 3000 });
	}

	deleteOrderTaxShortTermRentalJoinCB(orderTaxShortTermRentalJoin: OrderTaxShortTermRentalJoin) {
		console.log('Removing OrderTaxShortTermRentalJoin: ' + orderTaxShortTermRentalJoin);
		this.orderTaxShortTermRentalJoins.splice(this.orderTaxShortTermRentalJoins.indexOf(orderTaxShortTermRentalJoin), 1);
		this.recordTotal = this.orderTaxShortTermRentalJoins.length;

		// no idea what this is but it is required to update the array
		this.orderTaxShortTermRentalJoins = [...this.orderTaxShortTermRentalJoins];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderTaxShortTermRentalJoin ' + orderTaxShortTermRentalJoin.orderTaxShortTermRentalJoinId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.orderTaxShortTermRentalJoins ? this.first === (this.orderTaxShortTermRentalJoins.length - this.rows) : true; }
	isFirstPage(): boolean { return this.orderTaxShortTermRentalJoins ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(orderTaxShortTermRentalJoin: any) {
		if (orderTaxShortTermRentalJoin?.status) {
			const status = this.statuses.find((e: any) => e.value == orderTaxShortTermRentalJoin.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}
}
